/**
 * @file: description
 * @author: dongjing
 * @Date: 2020-02-24 14:47:56
 * @LastEditors: dongjing
 * @LastEditTime: 2020-02-26 17:43:57
 */
import { stringify } from 'querystring';
import { CM, Tction, call } from '@tkit/model';
import { TkitUtils as Utils } from '@tkit/types';
import {
  APIS,
  ParamsshopShoplistUsingGet,
  PageableResultShoppingInfo,
  ParamsBodyshopShopinfoUpdateUsingPut,
  ParamsBodyshopShopinfoAddUsingPost,
  ParamsshopProductUpdateProductIdUsingPut,
  ParamsshopOrderInfoUsingGet,
  ParamsshopChangeOrderOrderIdUsingPut,
  ShopUpdateVO,
  PageableResultOrderInfoVO
} from '@src/services';
import { message as Message } from 'antd';
import { PAGE_SIZE } from '@src/utils/constant/common';

export interface State {
  shopListModel: PageableResultShoppingInfo;
  loading: boolean;
  /** 订单列表 */
  orderListModel: PageableResultOrderInfoVO;
}

export const mallModelState: State = {
  shopListModel: {},
  loading: false,
  orderListModel: {}
};

const model = CM({
  state: mallModelState,
  namespace: 'mallModel',
  reducers: {
    /** 获取商品列表 */
    setShopList: (state, action: Tction<{ shopListModel: PageableResultShoppingInfo }>) => {
      const { shopListModel } = action.payload;
      return {
        ...state,
        shopListModel
      };
    },
    /** 更新商品列表信息 */
    updateShopList: (state, action: Tction<{ shopList: ShopUpdateVO }>) => {
      const {
        productId,
        accountSetType,
        icon,
        productName,
        productPrices,
        repertory
      } = action.payload.shopList;
      const { list } = state.shopListModel;
      return {
        ...state,
        shopListModel: {
          ...state.shopListModel,
          list:
            (list &&
              list.map(item => {
                if (item.productId === productId) {
                  return {
                    ...item,
                    accountSetType,
                    icon,
                    productName,
                    productPrices,
                    repertory
                  };
                }
                return { ...item };
              })) ||
            []
        }
      };
    },
    updateLoading: (state, action: Tction<{ loading: boolean }>) => {
      const { loading } = action.payload;
      return {
        ...state,
        loading
      };
    },
    /** 查询订单列表 */
    setOrderList: (state, action: Tction<{ orderListModel: PageableResultOrderInfoVO }>) => {
      const { orderListModel } = action.payload;
      return {
        ...state,
        orderListModel
      };
    },
    /** 更新订单列表 */
    updateOrderList: (state, action: Tction<{ orderId: string }>) => {
      const { orderId } = action.payload;
      const { list } = state.orderListModel;
      return {
        ...state,
        orderListModel: {
          ...state.orderListModel,
          list:
            list &&
            list.map(item => {
              if (item.orderId === orderId) {
                return {
                  ...item,
                  orderType: 3
                };
              }
              return item;
            })
        }
      };
    }
  },
  effects: {
    /** 获取商品列表 */
    *getShopList(
      { tPut, tCall },
      action: Tction<{
        params: ParamsshopShoplistUsingGet;
        needLoading?: boolean;
      }>
    ): Iterator<{}, any, any> {
      const { params, needLoading = true } = action.payload;
      if (needLoading) {
        yield tPut(model.actions.updateLoading, { loading: true });
      }
      const res: Utils.GetROA<typeof APIS.ShopApi.shopShoplistUsingGet> = yield tCall(
        APIS.ShopApi.shopShoplistUsingGet,
        params
      );
      const { code, result, message } = res;
      if (code === 0) {
        yield tPut(model.actions.setShopList, { shopListModel: result || {} });
      } else {
        Message.error(message);
      }
      if (needLoading) {
        yield tPut(model.actions.updateLoading, { loading: false });
      }
    },
    /**
     * @description 商品信息变更
     */
    *changeShopInfo(
      { tPut, tCall },
      action: Tction<{
        data: ParamsBodyshopShopinfoUpdateUsingPut;
        pageNum: number;
        pageSize: number;
      }>
    ): Iterator<{}, any, any> {
      const { data, pageNum, pageSize } = action.payload;
      const res: Utils.GetROA<typeof APIS.ShopApi.shopShopinfoUpdateUsingPut> = yield tCall(
        APIS.ShopApi.shopShopinfoUpdateUsingPut,
        data
      );
      const { code, message } = res;
      if (code === 0) {
        yield tPut(model.actions.getShopList, {
          params: { pageNum, pageSize },
          needLoading: false
        });
        Message.success('更新成功');
      } else {
        Message.error(message);
      }
    },
    /**
     * 添加商品
     */
    *addShopList(
      { tPut, tCall },
      action: Tction<{
        data: ParamsBodyshopShopinfoAddUsingPost;
        callBack?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { data, callBack } = action.payload;
      const res: Utils.GetROA<typeof APIS.ShopApi.shopShopinfoAddUsingPost> = yield tCall(
        APIS.ShopApi.shopShopinfoAddUsingPost,
        data
      );
      const { code, message } = res;
      if (code === 0) {
        Message.success('商品添加成功');
        yield tPut(model.actions.getShopList, { params: { pageNum: 1, pageSize: PAGE_SIZE } });
        callBack && callBack();
      } else {
        Message.error(message);
      }
    },
    /**
     * @description 商品上下架
     */
    *toggleOnSave(
      { tPut, tCall },
      action: Tction<{ params: ParamsshopProductUpdateProductIdUsingPut; pageNum: number }>
    ): Iterator<{}, any, any> {
      const { params, pageNum } = action.payload;
      const res: Utils.GetROA<typeof APIS.ShopApi.shopProductUpdateProductIdUsingPut> = yield tCall(
        APIS.ShopApi.shopProductUpdateProductIdUsingPut,
        params
      );
      const { code, message } = res;
      if (code === 0) {
        Message.success(params.isDeleted === 0 ? '成功上架该商品' : '该商品已下架');

        yield tPut(model.actions.getShopList, {
          params: { pageNum, pageSize: PAGE_SIZE },
          needLoading: false
        });
      } else {
        Message.error(message);
      }
    },
    /**
     * @description 查询订单列表
     */
    *searchOrderList(
      { tPut, tCall },
      action: Tction<{ params: ParamsshopOrderInfoUsingGet; needloading?: boolean }>
    ): Iterator<{}, any, any> {
      const { params, needloading = true } = action.payload;
      if (needloading) {
        yield tPut(model.actions.updateLoading, { loading: true });
      }

      const res: Utils.GetROA<typeof APIS.ShopApi.shopOrderInfoUsingGet> = yield tCall(
        APIS.ShopApi.shopOrderInfoUsingGet,
        params
      );
      const { code, message, result } = res;
      if (code === 0) {
        yield tPut(model.actions.setOrderList, { orderListModel: result || {} });
      } else {
        Message.error(message);
      }
      if (needloading) {
        yield tPut(model.actions.updateLoading, { loading: false });
      }
    },

    /**
     * @description 核销订单
     */
    *changeOrderType(
      { tPut, tCall },
      action: Tction<{
        params: ParamsshopChangeOrderOrderIdUsingPut;
        pageNum: number;
        pageSize: number;
      }>
    ): Iterator<{}, any, any> {
      const { params, pageNum, pageSize } = action.payload;
      const res: Utils.GetROA<typeof APIS.ShopApi.shopChangeOrderOrderIdUsingPut> = yield tCall(
        APIS.ShopApi.shopChangeOrderOrderIdUsingPut,
        params
      );
      const { code, message } = res;
      if (code === 0) {
        yield tPut(model.actions.updateOrderList, { orderId: params.orderId });
        Message.success('成功更新订单状态');
        // yield tPut(model.actions.searchOrderList, {
        //   params: { orderType: 0, pageSize, pageNum },
        //   needloading: false
        // });
      } else {
        Message.error(message);
      }
    }
  }
});

/**
 * @description 全局Model mallModel 挂载到 redux 上
 */
export default model;
